import {Check, X} from 'lucide-react'
import {useI18n} from '@/i18n'
import {IconText} from '@/components/shared/IconText'
import {EntityLink} from '@/components/shared/EntityLink'
import {formatTimestamp} from '@/lib/date-utils'
import {DetailsCard} from '@/components/shared/DetailsCard'
import type {OutboundConnector} from '@/types/outbound-connector'

interface ConnectorOverviewCardProps {
    connector: OutboundConnector
    connectorTypeLabel: string
}

export function ConnectorOverviewCard({connector, connectorTypeLabel}: ConnectorOverviewCardProps) {
    const i18n = useI18n()

    return (
        <DetailsCard
            data-testid="card-connector-overview"
            title={i18n.connectors.overview}
            description={i18n.connectors.basicInfo}
            columns={3}
            fields={[
                {
                    label: i18n.connectors.targetSystem,
                    value: <EntityLink value={connector.targetSystem} testId="link-target-system"/>,
                },
                {label: i18n.connectors.connectorType, value: connectorTypeLabel},
                {
                    label: i18n.common.status,
                    value: connector.enabled
                        ? <IconText icon={Check} iconClassName="text-status-success"><span>{i18n.common.enabled}</span></IconText>
                        : <IconText icon={X} iconClassName="text-muted-foreground"><span>{i18n.common.disabled}</span></IconText>,
                },
                {label: i18n.common.createdAt, value: formatTimestamp(connector.createdAt)},
                {label: i18n.common.lastUpdated, value: formatTimestamp(connector.updatedAt)},
            ]}
        />
    )
}
